export var TradevestEnvironment;
(function (TradevestEnvironment) {
    TradevestEnvironment["TEST"] = "test";
    TradevestEnvironment["PRODUCTION"] = "production";
})(TradevestEnvironment || (TradevestEnvironment = {}));
export var TradevestProvider;
(function (TradevestProvider) {
    TradevestProvider["SIMULATOR"] = "simulator";
    TradevestProvider["SANDBOX"] = "sandbox";
})(TradevestProvider || (TradevestProvider = {}));
export var TradevestGender;
(function (TradevestGender) {
    TradevestGender["MALE"] = "MALE";
    TradevestGender["FEMALE"] = "FEMALE";
    TradevestGender["DIVERSE"] = "DIVERSE";
})(TradevestGender || (TradevestGender = {}));
export var TradevestCountry;
(function (TradevestCountry) {
    TradevestCountry["DE"] = "DE";
    TradevestCountry["AT"] = "AT";
    TradevestCountry["CH"] = "CH";
    TradevestCountry["PL"] = "PL";
})(TradevestCountry || (TradevestCountry = {}));
export var TradevestTradingProfileAssetType;
(function (TradevestTradingProfileAssetType) {
    TradevestTradingProfileAssetType["BOND"] = "BOND";
    TradevestTradingProfileAssetType["ETF"] = "ETF";
    TradevestTradingProfileAssetType["EQUITY"] = "EQUITY";
    TradevestTradingProfileAssetType["FUND"] = "FUND";
    TradevestTradingProfileAssetType["COMMODITY"] = "COMMODITY";
    TradevestTradingProfileAssetType["DERIVATIVE"] = "DERIVATIVE";
    TradevestTradingProfileAssetType["ETN"] = "ETN";
    TradevestTradingProfileAssetType["SECURITY_TOKEN"] = "SECURITY_TOKEN";
    TradevestTradingProfileAssetType["CRYPTOCURRENCY"] = "CRYPTOCURRENCY";
    TradevestTradingProfileAssetType["TRACKER_CERTIFICATE"] = "TRACKER_CERTIFICATE";
    TradevestTradingProfileAssetType["EWP"] = "EWP";
})(TradevestTradingProfileAssetType || (TradevestTradingProfileAssetType = {}));
export var TradevestNaturalPersonStatus;
(function (TradevestNaturalPersonStatus) {
    TradevestNaturalPersonStatus["CREATED"] = "CREATED";
    TradevestNaturalPersonStatus["REVIEW"] = "REVIEW";
    TradevestNaturalPersonStatus["REJECTED"] = "REJECTED";
    TradevestNaturalPersonStatus["INACTIVE"] = "INACTIVE";
    TradevestNaturalPersonStatus["PENDING"] = "PENDING";
    TradevestNaturalPersonStatus["ACTIVE"] = "ACTIVE";
    TradevestNaturalPersonStatus["SUSPENDED"] = "SUSPENDED";
    TradevestNaturalPersonStatus["ARCHIVED"] = "ARCHIVED";
    TradevestNaturalPersonStatus["RECEIVED"] = "RECEIVED";
    TradevestNaturalPersonStatus["INVALID"] = "INVALID";
    TradevestNaturalPersonStatus["SUSPENDED_COMPLIANCE"] = "SUSPENDED_COMPLIANCE";
    TradevestNaturalPersonStatus["DECEASED"] = "DECEASED";
})(TradevestNaturalPersonStatus || (TradevestNaturalPersonStatus = {}));
export var TradevestProductCode;
(function (TradevestProductCode) {
    TradevestProductCode["WALLET"] = "WALLET";
    TradevestProductCode["BALANCE_ACCOUNT"] = "BALANCE_ACCOUNT";
    TradevestProductCode["DEPOSITORY_ACCOUNT"] = "DEPOSITORY_ACCOUNT";
    TradevestProductCode["CURRENCY_WALLET"] = "CURRENCY_WALLET";
})(TradevestProductCode || (TradevestProductCode = {}));
export var TradevestProductType;
(function (TradevestProductType) {
    TradevestProductType["CASH"] = "CASH";
    TradevestProductType["WALLET"] = "WALLET";
    TradevestProductType["DEPOSITORY"] = "DEPOSITORY";
})(TradevestProductType || (TradevestProductType = {}));
export var TradevestCustomerProductStatus;
(function (TradevestCustomerProductStatus) {
    TradevestCustomerProductStatus["RECEIVED"] = "RECEIVED";
    TradevestCustomerProductStatus["INVALID"] = "INVALID";
    TradevestCustomerProductStatus["PENDING"] = "PENDING";
    TradevestCustomerProductStatus["ACTIVE"] = "ACTIVE";
    TradevestCustomerProductStatus["BLOCKED"] = "BLOCKED";
    TradevestCustomerProductStatus["RESTRICTED"] = "RESTRICTED";
    TradevestCustomerProductStatus["INACTIVE"] = "INACTIVE";
    TradevestCustomerProductStatus["CLOSED"] = "CLOSED";
    TradevestCustomerProductStatus["REJECTED"] = "REJECTED";
})(TradevestCustomerProductStatus || (TradevestCustomerProductStatus = {}));
export const TRADEVEST_MAX_ORDER_AMOUNT_EUR = 100000;
export const TRADEVEST_DIGITAL_MIN_ORDER_AMOUNT_EUR = 11;
export var TradevestTradeSide;
(function (TradevestTradeSide) {
    TradevestTradeSide["BUY"] = "BUY";
    TradevestTradeSide["SELL"] = "SELL";
})(TradevestTradeSide || (TradevestTradeSide = {}));
export var TradevestQuantityType;
(function (TradevestQuantityType) {
    TradevestQuantityType["UNIT"] = "UNIT";
    TradevestQuantityType["AMOUNT"] = "AMOUNT";
})(TradevestQuantityType || (TradevestQuantityType = {}));
export var TradevestOrderStatus;
(function (TradevestOrderStatus) {
    TradevestOrderStatus["RECEIVED"] = "RECEIVED";
    TradevestOrderStatus["INVALID"] = "INVALID";
    TradevestOrderStatus["PENDING"] = "PENDING";
    TradevestOrderStatus["CANCELED"] = "CANCELED";
    TradevestOrderStatus["REJECTED"] = "REJECTED";
    TradevestOrderStatus["FILLED"] = "FILLED";
    TradevestOrderStatus["CORRECTED"] = "CORRECTED";
    TradevestOrderStatus["SETTLED"] = "SETTLED";
})(TradevestOrderStatus || (TradevestOrderStatus = {}));
export var TradevestDigitalAssetType;
(function (TradevestDigitalAssetType) {
    TradevestDigitalAssetType["CRYPTOCURRENCY"] = "CRYPTOCURRENCY";
    TradevestDigitalAssetType["SECURITYTOKEN"] = "SECURITYTOKEN";
})(TradevestDigitalAssetType || (TradevestDigitalAssetType = {}));
export var TradevestRail;
(function (TradevestRail) {
    TradevestRail["DIGITAL"] = "DIGITAL";
    TradevestRail["WAWEX"] = "WAWEX";
})(TradevestRail || (TradevestRail = {}));
export var TradevestWawexAssetType;
(function (TradevestWawexAssetType) {
    TradevestWawexAssetType["TRACKER_CERTIFICATE"] = "TRACKERCERTIFICATE";
    TradevestWawexAssetType["EWP"] = "eWP";
})(TradevestWawexAssetType || (TradevestWawexAssetType = {}));
export var TradevestWawexOrderStatus;
(function (TradevestWawexOrderStatus) {
    TradevestWawexOrderStatus["RECEIVED"] = "RECEIVED";
    TradevestWawexOrderStatus["INVALID"] = "INVALID";
    TradevestWawexOrderStatus["PENDING"] = "PENDING";
    TradevestWawexOrderStatus["CANCELLED"] = "CANCELLED";
    TradevestWawexOrderStatus["EXPIRED"] = "EXPIRED";
    TradevestWawexOrderStatus["REJECTED"] = "REJECTED";
    TradevestWawexOrderStatus["FILLED"] = "FILLED";
    TradevestWawexOrderStatus["PARTIALLY_FILLED"] = "PARTIALLY_FILLED";
    TradevestWawexOrderStatus["PARTIALLY_FILLED_CANCELLED"] = "PARTIALLY_FILLED_CANCELLED";
    TradevestWawexOrderStatus["PARTIALLY_FILLED_EXPIRED"] = "PARTIALLY_FILLED_EXPIRED";
    TradevestWawexOrderStatus["CORRECTED"] = "CORRECTED";
    TradevestWawexOrderStatus["SETTLED"] = "SETTLED";
})(TradevestWawexOrderStatus || (TradevestWawexOrderStatus = {}));
export const TRADEVEST_EWP_MIN_ORDER_AMOUNT_EUR = 1000;
export const TRADEVEST_EWP_MAX_ORDER_AMOUNT_EUR = 8000000;
export const TRADEVEST_EWP_UNIT_DECIMALS = 8;
export var TradevestTraditionalAssetType;
(function (TradevestTraditionalAssetType) {
    TradevestTraditionalAssetType["BOND"] = "BOND";
    TradevestTraditionalAssetType["ETF"] = "ETF";
    TradevestTraditionalAssetType["EQUITY"] = "EQUITY";
    TradevestTraditionalAssetType["FUND"] = "FUND";
    TradevestTraditionalAssetType["COMMODITY"] = "COMMODITY";
    TradevestTraditionalAssetType["DERIVATIVE"] = "DERIVATIVE";
    TradevestTraditionalAssetType["ETN"] = "ETN";
    TradevestTraditionalAssetType["UNKNOWN"] = "UNKNOWN";
})(TradevestTraditionalAssetType || (TradevestTraditionalAssetType = {}));
export var TradevestExchangeCode;
(function (TradevestExchangeCode) {
    TradevestExchangeCode["TGAT"] = "TGAT";
    TradevestExchangeCode["XFRA"] = "XFRA";
})(TradevestExchangeCode || (TradevestExchangeCode = {}));
export var TradevestTraditionalTradingStatus;
(function (TradevestTraditionalTradingStatus) {
    TradevestTraditionalTradingStatus["ACTIVE"] = "ACTIVE";
    TradevestTraditionalTradingStatus["INACTIVE"] = "INACTIVE";
})(TradevestTraditionalTradingStatus || (TradevestTraditionalTradingStatus = {}));
export const TRADEVEST_CATALOG_SORTS = ['name', 'nameDesc', 'ter', 'risk'];
export var TradevestOrderEmailSuppressedReason;
(function (TradevestOrderEmailSuppressedReason) {
    TradevestOrderEmailSuppressedReason["NO_EMAIL"] = "NO_EMAIL";
    TradevestOrderEmailSuppressedReason["USER_GONE"] = "USER_GONE";
    TradevestOrderEmailSuppressedReason["STATUS_MISMATCH"] = "STATUS_MISMATCH";
    TradevestOrderEmailSuppressedReason["OWNERSHIP_MISMATCH"] = "OWNERSHIP_MISMATCH";
    TradevestOrderEmailSuppressedReason["ALREADY_TERMINAL"] = "ALREADY_TERMINAL";
    TradevestOrderEmailSuppressedReason["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
})(TradevestOrderEmailSuppressedReason || (TradevestOrderEmailSuppressedReason = {}));
export var TradevestOrderEmailAttachmentSkipReason;
(function (TradevestOrderEmailAttachmentSkipReason) {
    TradevestOrderEmailAttachmentSkipReason["NOT_READY"] = "NOT_READY";
    TradevestOrderEmailAttachmentSkipReason["NO_EXECUTION_ID"] = "NO_EXECUTION_ID";
    TradevestOrderEmailAttachmentSkipReason["NO_EX_ANTE_ID"] = "NO_EX_ANTE_ID";
    TradevestOrderEmailAttachmentSkipReason["UNTRUSTED_EX_ANTE_ID"] = "UNTRUSTED_EX_ANTE_ID";
    TradevestOrderEmailAttachmentSkipReason["UNTRUSTED_EXECUTION_ID"] = "UNTRUSTED_EXECUTION_ID";
    TradevestOrderEmailAttachmentSkipReason["PDF_FAILED"] = "PDF_FAILED";
    TradevestOrderEmailAttachmentSkipReason["MISSING_RECEIPT_DATA"] = "MISSING_RECEIPT_DATA";
    TradevestOrderEmailAttachmentSkipReason["TOO_LARGE"] = "TOO_LARGE";
})(TradevestOrderEmailAttachmentSkipReason || (TradevestOrderEmailAttachmentSkipReason = {}));
export var TradevestTraditionalOrderType;
(function (TradevestTraditionalOrderType) {
    TradevestTraditionalOrderType["MARKET"] = "MARKET";
    TradevestTraditionalOrderType["LIMIT"] = "LIMIT";
    TradevestTraditionalOrderType["STOP"] = "STOP";
})(TradevestTraditionalOrderType || (TradevestTraditionalOrderType = {}));
export var TradevestTraditionalOrderStatus;
(function (TradevestTraditionalOrderStatus) {
    TradevestTraditionalOrderStatus["RECEIVED"] = "RECEIVED";
    TradevestTraditionalOrderStatus["INVALID"] = "INVALID";
    TradevestTraditionalOrderStatus["PLACED"] = "PLACED";
    TradevestTraditionalOrderStatus["UPDATED"] = "UPDATED";
    TradevestTraditionalOrderStatus["REJECTED"] = "REJECTED";
    TradevestTraditionalOrderStatus["FILLED"] = "FILLED";
    TradevestTraditionalOrderStatus["PARTIALLY_FILLED"] = "PARTIALLY_FILLED";
    TradevestTraditionalOrderStatus["CANCELLED"] = "CANCELLED";
    TradevestTraditionalOrderStatus["RECONCILIATION_CORRECTION"] = "RECONCILIATION_CORRECTION";
    TradevestTraditionalOrderStatus["EXPIRED"] = "EXPIRED";
    TradevestTraditionalOrderStatus["PENDING"] = "PENDING";
    TradevestTraditionalOrderStatus["CANCELLATION_REJECTED"] = "CANCELLATION_REJECTED";
    TradevestTraditionalOrderStatus["CANCELLATION_ACCEPTED"] = "CANCELLATION_ACCEPTED";
    TradevestTraditionalOrderStatus["PARTIALLY_FILLED_CANCELLED"] = "PARTIALLY_FILLED_CANCELLED";
    TradevestTraditionalOrderStatus["PARTIALLY_FILLED_EXPIRED"] = "PARTIALLY_FILLED_EXPIRED";
})(TradevestTraditionalOrderStatus || (TradevestTraditionalOrderStatus = {}));
export var TradevestInstrumentType;
(function (TradevestInstrumentType) {
    TradevestInstrumentType["DIGITAL_ASSET"] = "DIGITAL_ASSET";
    TradevestInstrumentType["TRADITIONAL_ASSET"] = "TRADITIONAL_ASSET";
})(TradevestInstrumentType || (TradevestInstrumentType = {}));
export var TradevestSavingsPlanStatus;
(function (TradevestSavingsPlanStatus) {
    TradevestSavingsPlanStatus["ACTIVE"] = "ACTIVE";
    TradevestSavingsPlanStatus["INACTIVE"] = "INACTIVE";
    TradevestSavingsPlanStatus["PENDING"] = "PENDING";
    TradevestSavingsPlanStatus["DELETED"] = "DELETED";
})(TradevestSavingsPlanStatus || (TradevestSavingsPlanStatus = {}));
export var TradevestSavingsPlanIntervalPeriod;
(function (TradevestSavingsPlanIntervalPeriod) {
    TradevestSavingsPlanIntervalPeriod["MONTH"] = "MONTH";
})(TradevestSavingsPlanIntervalPeriod || (TradevestSavingsPlanIntervalPeriod = {}));
export var TradevestSavingsPlanIntervalDay;
(function (TradevestSavingsPlanIntervalDay) {
    TradevestSavingsPlanIntervalDay["DAY_1"] = "1";
    TradevestSavingsPlanIntervalDay["DAY_16"] = "16";
})(TradevestSavingsPlanIntervalDay || (TradevestSavingsPlanIntervalDay = {}));
export var TradevestSavingsPlanToggleStatus;
(function (TradevestSavingsPlanToggleStatus) {
    TradevestSavingsPlanToggleStatus["ACTIVE"] = "ACTIVE";
    TradevestSavingsPlanToggleStatus["INACTIVE"] = "INACTIVE";
})(TradevestSavingsPlanToggleStatus || (TradevestSavingsPlanToggleStatus = {}));
export var TradevestAssetRiskScore;
(function (TradevestAssetRiskScore) {
    TradevestAssetRiskScore["ZERO"] = "0";
    TradevestAssetRiskScore["THREE"] = "3";
})(TradevestAssetRiskScore || (TradevestAssetRiskScore = {}));
export var TradevestExternalVerifier;
(function (TradevestExternalVerifier) {
    TradevestExternalVerifier["DEUTSCHE_POST"] = "DEUTSCHE_POST";
    TradevestExternalVerifier["WEB_ID"] = "WEB_ID";
    TradevestExternalVerifier["ID_NOW"] = "ID_NOW";
    TradevestExternalVerifier["PARTNER"] = "PARTNER";
    TradevestExternalVerifier["OTHER"] = "OTHER";
})(TradevestExternalVerifier || (TradevestExternalVerifier = {}));
export var TradevestIdentificationType;
(function (TradevestIdentificationType) {
    TradevestIdentificationType["POST_IDENT"] = "POST_IDENT";
    TradevestIdentificationType["VIDEO_IDENT"] = "VIDEO_IDENT";
    TradevestIdentificationType["IN_PERSON"] = "IN_PERSON";
    TradevestIdentificationType["E_ID"] = "E_ID";
    TradevestIdentificationType["ID_COPY"] = "ID_COPY";
})(TradevestIdentificationType || (TradevestIdentificationType = {}));
export var TradevestIdentificationDocumentType;
(function (TradevestIdentificationDocumentType) {
    TradevestIdentificationDocumentType["ID"] = "ID";
    TradevestIdentificationDocumentType["PASSPORT"] = "PASSPORT";
    TradevestIdentificationDocumentType["BIRTH_CERTIFICATE"] = "BIRTH_CERTIFICATE";
})(TradevestIdentificationDocumentType || (TradevestIdentificationDocumentType = {}));
export var TradevestIdentificationVerificationStatus;
(function (TradevestIdentificationVerificationStatus) {
    TradevestIdentificationVerificationStatus["RECEIVED"] = "RECEIVED";
    TradevestIdentificationVerificationStatus["PENDING"] = "PENDING";
    TradevestIdentificationVerificationStatus["APPROVED"] = "APPROVED";
    TradevestIdentificationVerificationStatus["REJECTED"] = "REJECTED";
})(TradevestIdentificationVerificationStatus || (TradevestIdentificationVerificationStatus = {}));
export var TradevestDocumentType;
(function (TradevestDocumentType) {
    TradevestDocumentType["IDENTIFICATION_CERTIFICATE"] = "IDENTIFICATION_CERTIFICATE";
    TradevestDocumentType["PROOF_OF_RESIDENCE"] = "PROOF_OF_RESIDENCE";
    TradevestDocumentType["DATA_PRIVACY_POLICY"] = "DATA_PRIVACY_POLICY";
    TradevestDocumentType["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
    TradevestDocumentType["CONTRACT"] = "CONTRACT";
    TradevestDocumentType["OTHER"] = "OTHER";
})(TradevestDocumentType || (TradevestDocumentType = {}));
export var TradevestDocumentResourceType;
(function (TradevestDocumentResourceType) {
    TradevestDocumentResourceType["NATURAL_PERSON"] = "NATURAL_PERSON";
    TradevestDocumentResourceType["CUSTOMER"] = "CUSTOMER";
    TradevestDocumentResourceType["LEGAL_ENTITY"] = "LEGAL_ENTITY";
})(TradevestDocumentResourceType || (TradevestDocumentResourceType = {}));
export var TradevestCustomerStatus;
(function (TradevestCustomerStatus) {
    TradevestCustomerStatus["RECEIVED"] = "RECEIVED";
    TradevestCustomerStatus["CREATED"] = "CREATED";
    TradevestCustomerStatus["REVIEW"] = "REVIEW";
    TradevestCustomerStatus["REJECTED"] = "REJECTED";
    TradevestCustomerStatus["INACTIVE"] = "INACTIVE";
    TradevestCustomerStatus["ACTIVE"] = "ACTIVE";
    TradevestCustomerStatus["SUSPENDED"] = "SUSPENDED";
    TradevestCustomerStatus["ARCHIVED"] = "ARCHIVED";
    TradevestCustomerStatus["INVALID"] = "INVALID";
    TradevestCustomerStatus["PENDING"] = "PENDING";
    TradevestCustomerStatus["SUSPENDED_COMPLIANCE"] = "SUSPENDED_COMPLIANCE";
    TradevestCustomerStatus["ESTATE"] = "ESTATE";
    TradevestCustomerStatus["OFFBOARDING"] = "OFFBOARDING";
})(TradevestCustomerStatus || (TradevestCustomerStatus = {}));
export var TradevestOnboardingType;
(function (TradevestOnboardingType) {
    TradevestOnboardingType["CUSTOMER"] = "CUSTOMER";
    TradevestOnboardingType["PROXY"] = "PROXY";
})(TradevestOnboardingType || (TradevestOnboardingType = {}));
export var TradevestOnboardingStatus;
(function (TradevestOnboardingStatus) {
    TradevestOnboardingStatus["RECEIVED"] = "RECEIVED";
    TradevestOnboardingStatus["INVALID"] = "INVALID";
    TradevestOnboardingStatus["CREATED"] = "CREATED";
    TradevestOnboardingStatus["NEW"] = "NEW";
    TradevestOnboardingStatus["PENDING"] = "PENDING";
    TradevestOnboardingStatus["APPROVED"] = "APPROVED";
    TradevestOnboardingStatus["REJECTED"] = "REJECTED";
})(TradevestOnboardingStatus || (TradevestOnboardingStatus = {}));
export var TradevestOffboardingStatus;
(function (TradevestOffboardingStatus) {
    TradevestOffboardingStatus["RECEIVED"] = "RECEIVED";
    TradevestOffboardingStatus["CREATED"] = "CREATED";
    TradevestOffboardingStatus["PENDING"] = "PENDING";
    TradevestOffboardingStatus["INVALID"] = "INVALID";
    TradevestOffboardingStatus["REJECTED"] = "REJECTED";
    TradevestOffboardingStatus["CANCELED"] = "CANCELED";
    TradevestOffboardingStatus["APPROVED"] = "APPROVED";
})(TradevestOffboardingStatus || (TradevestOffboardingStatus = {}));
export var TradevestOffboardingReason;
(function (TradevestOffboardingReason) {
    TradevestOffboardingReason["CUSTOMER_REQUEST_IMMEDIATE"] = "CUSTOMER_REQUEST_IMMEDIATE";
})(TradevestOffboardingReason || (TradevestOffboardingReason = {}));
export var TradevestEligibilityReason;
(function (TradevestEligibilityReason) {
    TradevestEligibilityReason["ELIGIBLE"] = "ELIGIBLE";
    TradevestEligibilityReason["ALREADY_REGISTERED"] = "ALREADY_REGISTERED";
    TradevestEligibilityReason["ONBOARDING_IN_PROGRESS"] = "ONBOARDING_IN_PROGRESS";
    TradevestEligibilityReason["NO_KYC_CASE"] = "NO_KYC_CASE";
    TradevestEligibilityReason["KYC_NOT_FOUND"] = "KYC_NOT_FOUND";
    TradevestEligibilityReason["KYC_NOT_SUCCESSFUL"] = "KYC_NOT_SUCCESSFUL";
    TradevestEligibilityReason["KYC_EXPIRED"] = "KYC_EXPIRED";
    TradevestEligibilityReason["KYC_MISSING_POSTIDENT_ID"] = "KYC_MISSING_POSTIDENT_ID";
    TradevestEligibilityReason["INCOMPLETE_USER_DATA"] = "INCOMPLETE_USER_DATA";
    TradevestEligibilityReason["INCOMPLETE_KYC_DATA"] = "INCOMPLETE_KYC_DATA";
    TradevestEligibilityReason["TAX_ID_REQUIRED"] = "TAX_ID_REQUIRED";
    TradevestEligibilityReason["INTERNAL_ERROR"] = "INTERNAL_ERROR";
})(TradevestEligibilityReason || (TradevestEligibilityReason = {}));
export var TradevestWebhookEventType;
(function (TradevestWebhookEventType) {
    TradevestWebhookEventType["NATURAL_PERSON_NOTIFICATION"] = "NATURAL_PERSON_NOTIFICATION";
    TradevestWebhookEventType["ONBOARDING_NOTIFICATION"] = "ONBOARDING_NOTIFICATION";
    TradevestWebhookEventType["CUSTOMER_NOTIFICATION"] = "CUSTOMER_NOTIFICATION";
    TradevestWebhookEventType["CUSTOMER_PRODUCT_NOTIFICATION"] = "CUSTOMER_PRODUCT_NOTIFICATION";
    TradevestWebhookEventType["DOCUMENT_NOTIFICATION"] = "DOCUMENT_NOTIFICATION";
    TradevestWebhookEventType["IDENTIFICATION_VERIFICATION_NOTIFICATION"] = "IDENTIFICATION_VERIFICATION_NOTIFICATION";
    TradevestWebhookEventType["TRANSFER_NOTIFICATION"] = "TRANSFER_NOTIFICATION";
    TradevestWebhookEventType["OFFBOARDING_NOTIFICATION"] = "OFFBOARDING_NOTIFICATION";
    TradevestWebhookEventType["LEGAL_ENTITY_NOTIFICATION"] = "LEGAL_ENTITY_NOTIFICATION";
    TradevestWebhookEventType["LEGAL_ENTITY_SEARCH_NOTIFICATION"] = "LEGAL_ENTITY_SEARCH_NOTIFICATION";
    TradevestWebhookEventType["LEGAL_REPRESENTATIVE_NOTIFICATION"] = "LEGAL_REPRESENTATIVE_NOTIFICATION";
    TradevestWebhookEventType["LABELS_UPDATE_NOTIFICATION"] = "LABELS_UPDATE_NOTIFICATION";
    TradevestWebhookEventType["DIGITAL_ASSET_ORDER_NOTIFICATION"] = "DIGITAL_ASSET_ORDER_NOTIFICATION";
    TradevestWebhookEventType["TRADITIONAL_ASSET_ORDER_NOTIFICATION"] = "TRADITIONAL_ASSET_ORDER_NOTIFICATION";
    TradevestWebhookEventType["TOKENIZED_ASSET_ORDER_NOTIFICATION"] = "TOKENIZED_ASSET_ORDER_NOTIFICATION";
    TradevestWebhookEventType["WAWEX_EX_ANTE_DOCUMENT_READY_NOTIFICATION"] = "WAWEX_EX_ANTE_DOCUMENT_READY_NOTIFICATION";
    TradevestWebhookEventType["PROXY_NOTIFICATION"] = "PROXY_NOTIFICATION";
    TradevestWebhookEventType["BENEFICIAL_OWNER_NOTIFICATION"] = "BENEFICIAL_OWNER_NOTIFICATION";
    TradevestWebhookEventType["USER_NOTIFICATION"] = "USER_NOTIFICATION";
    TradevestWebhookEventType["RE_TOKEN_PRICES"] = "RE_TOKEN_PRICES";
    TradevestWebhookEventType["STRATEGY_NOTIFICATION"] = "STRATEGY_NOTIFICATION";
    TradevestWebhookEventType["PARTNER_NOTIFICATION"] = "PARTNER_NOTIFICATION";
    TradevestWebhookEventType["PARTNER_DOCUMENT_NOTIFICATION"] = "PARTNER_DOCUMENT_NOTIFICATION";
    TradevestWebhookEventType["JOINT_PERSON_NOTIFICATION"] = "JOINT_PERSON_NOTIFICATION";
    TradevestWebhookEventType["TAX_EXEMPTION_ORDER_NOTIFICATION"] = "TAX_EXEMPTION_ORDER_NOTIFICATION";
    TradevestWebhookEventType["CORPORATE_ACTION_NOTIFICATION"] = "CORPORATE_ACTION_NOTIFICATION";
})(TradevestWebhookEventType || (TradevestWebhookEventType = {}));
export var TradevestUndeliveredWebhookStatus;
(function (TradevestUndeliveredWebhookStatus) {
    TradevestUndeliveredWebhookStatus["FAILING"] = "FAILING";
    TradevestUndeliveredWebhookStatus["SKIPPED"] = "SKIPPED";
    TradevestUndeliveredWebhookStatus["STALE"] = "STALE";
    TradevestUndeliveredWebhookStatus["UNREADABLE"] = "UNREADABLE";
    TradevestUndeliveredWebhookStatus["RECOVERED"] = "RECOVERED";
})(TradevestUndeliveredWebhookStatus || (TradevestUndeliveredWebhookStatus = {}));
export var TradevestTaxValidationErrorCode;
(function (TradevestTaxValidationErrorCode) {
    TradevestTaxValidationErrorCode["ALREADY_EXISTS_ERROR"] = "ALREADY_EXISTS_ERROR";
    TradevestTaxValidationErrorCode["DATA_NOT_FOUND_ERROR"] = "DATA_NOT_FOUND_ERROR";
    TradevestTaxValidationErrorCode["INVALID_DATA_ERROR"] = "INVALID_DATA_ERROR";
    TradevestTaxValidationErrorCode["INAPPROPRIATE_DATA_STATUS_ERROR"] = "INAPPROPRIATE_DATA_STATUS_ERROR";
    TradevestTaxValidationErrorCode["DATA_MISSING_ERROR"] = "DATA_MISSING_ERROR";
    TradevestTaxValidationErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(TradevestTaxValidationErrorCode || (TradevestTaxValidationErrorCode = {}));
export var TradevestOrderFailureCode;
(function (TradevestOrderFailureCode) {
    TradevestOrderFailureCode["INSUFFICIENT_BALANCE"] = "INSUFFICIENT_BALANCE";
    TradevestOrderFailureCode["ORDER_CASH_AMOUNT_OUT_OF_BOUNDS"] = "ORDER_CASH_AMOUNT_OUT_OF_BOUNDS";
    TradevestOrderFailureCode["INSUFFICIENT_POSITION"] = "INSUFFICIENT_POSITION";
})(TradevestOrderFailureCode || (TradevestOrderFailureCode = {}));
export var TradevestTradingAssetType;
(function (TradevestTradingAssetType) {
    TradevestTradingAssetType["CRYPTOCURRENCY"] = "CRYPTOCURRENCY";
})(TradevestTradingAssetType || (TradevestTradingAssetType = {}));
export var TradevestAcknowledgmentVersionCode;
(function (TradevestAcknowledgmentVersionCode) {
    TradevestAcknowledgmentVersionCode["DE_2025"] = "ACKNOWLEDGMENT_BASIC_PROFILE_V1_DE_2025";
    TradevestAcknowledgmentVersionCode["EN_2025"] = "ACKNOWLEDGMENT_BASIC_PROFILE_V1_EN_2025";
})(TradevestAcknowledgmentVersionCode || (TradevestAcknowledgmentVersionCode = {}));
export var TradevestAppropriatenessAssetType;
(function (TradevestAppropriatenessAssetType) {
    TradevestAppropriatenessAssetType["SECURITY_TOKEN"] = "SECURITY_TOKEN";
    TradevestAppropriatenessAssetType["TRACKER_CERTIFICATE"] = "TRACKER_CERTIFICATE";
    TradevestAppropriatenessAssetType["EWP"] = "EWP";
})(TradevestAppropriatenessAssetType || (TradevestAppropriatenessAssetType = {}));
export var TradevestAppropriatenessStatus;
(function (TradevestAppropriatenessStatus) {
    TradevestAppropriatenessStatus["RECEIVED"] = "RECEIVED";
    TradevestAppropriatenessStatus["PASSED"] = "PASSED";
    TradevestAppropriatenessStatus["FAILED"] = "FAILED";
    TradevestAppropriatenessStatus["INVALID"] = "INVALID";
})(TradevestAppropriatenessStatus || (TradevestAppropriatenessStatus = {}));
export var TradevestTransferStatus;
(function (TradevestTransferStatus) {
    TradevestTransferStatus["RECEIVED"] = "RECEIVED";
    TradevestTransferStatus["INVALID"] = "INVALID";
    TradevestTransferStatus["PENDING"] = "PENDING";
    TradevestTransferStatus["REJECTED"] = "REJECTED";
    TradevestTransferStatus["PROCESSED"] = "PROCESSED";
    TradevestTransferStatus["RECONCILED"] = "RECONCILED";
})(TradevestTransferStatus || (TradevestTransferStatus = {}));
export var TradevestTransactionType;
(function (TradevestTransactionType) {
    TradevestTransactionType["INCOMING_TRANSFER"] = "INCOMING_TRANSFER";
    TradevestTransactionType["OUTGOING_TRANSFER"] = "OUTGOING_TRANSFER";
})(TradevestTransactionType || (TradevestTransactionType = {}));
export var TradevestTransferValidationError;
(function (TradevestTransferValidationError) {
    TradevestTransferValidationError["INSUFFICIENT_BALANCE"] = "INSUFFICIENT_BALANCE";
    TradevestTransferValidationError["INVALID_IBAN"] = "INVALID_IBAN";
    TradevestTransferValidationError["IBAN_BIC_MISMATCH"] = "IBAN_BIC_MISMATCH";
    TradevestTransferValidationError["ACTIVE_PRODUCT_REQUIRED"] = "ACTIVE_PRODUCT_REQUIRED";
    TradevestTransferValidationError["PRODUCT_NOT_FOUND"] = "PRODUCT_NOT_FOUND";
    TradevestTransferValidationError["ACTIVE_CUSTOMER_REQUIRED"] = "ACTIVE_CUSTOMER_REQUIRED";
    TradevestTransferValidationError["CUSTOMER_NOT_FOUND"] = "CUSTOMER_NOT_FOUND";
    TradevestTransferValidationError["DATA_NOT_FOUND_ERROR"] = "DATA_NOT_FOUND_ERROR";
    TradevestTransferValidationError["INAPPROPRIATE_DATA_STATUS_ERROR"] = "INAPPROPRIATE_DATA_STATUS_ERROR";
    TradevestTransferValidationError["REF_ACCOUNT_OR_ACCOUNT_PRODUCT_IBAN_REQUIRED"] = "REF_ACCOUNT_OR_ACCOUNT_PRODUCT_IBAN_REQUIRED";
    TradevestTransferValidationError["ACCOUNT_PRODUCT_REQUIRED"] = "ACCOUNT_PRODUCT_REQUIRED";
    TradevestTransferValidationError["INSUFFICIENT_WITHDRAWABLE_BALANCE"] = "INSUFFICIENT_WITHDRAWABLE_BALANCE";
    TradevestTransferValidationError["RECEIVER_IBAN_SAME_AS_PRODUCT_IBAN"] = "RECEIVER_IBAN_SAME_AS_PRODUCT_IBAN";
    TradevestTransferValidationError["REQUESTOR_ID_NOT_VALID"] = "REQUESTOR_ID_NOT_VALID";
})(TradevestTransferValidationError || (TradevestTransferValidationError = {}));
export var TradevestOnboardingEventType;
(function (TradevestOnboardingEventType) {
    TradevestOnboardingEventType["ONBOARDING_INITIATED"] = "ONBOARDING_INITIATED";
    TradevestOnboardingEventType["ELIGIBILITY_CHECK"] = "ELIGIBILITY_CHECK";
    TradevestOnboardingEventType["JOB_SCHEDULED"] = "JOB_SCHEDULED";
    TradevestOnboardingEventType["JOB_STARTED"] = "JOB_STARTED";
    TradevestOnboardingEventType["JOB_COMPLETED"] = "JOB_COMPLETED";
    TradevestOnboardingEventType["JOB_FAILED"] = "JOB_FAILED";
    TradevestOnboardingEventType["NATURAL_PERSON_CREATION_STARTED"] = "NATURAL_PERSON_CREATION_STARTED";
    TradevestOnboardingEventType["NATURAL_PERSON_CREATED"] = "NATURAL_PERSON_CREATED";
    TradevestOnboardingEventType["NATURAL_PERSON_CREATION_FAILED"] = "NATURAL_PERSON_CREATION_FAILED";
    TradevestOnboardingEventType["NATURAL_PERSON_ALREADY_EXISTS"] = "NATURAL_PERSON_ALREADY_EXISTS";
    TradevestOnboardingEventType["NATURAL_PERSON_STATUS_POLLED"] = "NATURAL_PERSON_STATUS_POLLED";
    TradevestOnboardingEventType["NATURAL_PERSON_ACTIVATED"] = "NATURAL_PERSON_ACTIVATED";
    TradevestOnboardingEventType["IDENTIFICATION_UPLOAD_STARTED"] = "IDENTIFICATION_UPLOAD_STARTED";
    TradevestOnboardingEventType["IDENTIFICATION_UPLOADED"] = "IDENTIFICATION_UPLOADED";
    TradevestOnboardingEventType["IDENTIFICATION_UPLOAD_FAILED"] = "IDENTIFICATION_UPLOAD_FAILED";
    TradevestOnboardingEventType["IDENTITY_CREATION_STARTED"] = "IDENTITY_CREATION_STARTED";
    TradevestOnboardingEventType["IDENTITY_CREATED"] = "IDENTITY_CREATED";
    TradevestOnboardingEventType["IDENTITY_CREATION_FAILED"] = "IDENTITY_CREATION_FAILED";
    TradevestOnboardingEventType["CUSTOMER_CREATION_STARTED"] = "CUSTOMER_CREATION_STARTED";
    TradevestOnboardingEventType["CUSTOMER_CREATED"] = "CUSTOMER_CREATED";
    TradevestOnboardingEventType["CUSTOMER_CREATION_FAILED"] = "CUSTOMER_CREATION_FAILED";
    TradevestOnboardingEventType["CUSTOMER_ALREADY_EXISTS"] = "CUSTOMER_ALREADY_EXISTS";
    TradevestOnboardingEventType["BANK_DETAILS_SUBMITTED"] = "BANK_DETAILS_SUBMITTED";
    TradevestOnboardingEventType["PROFILE_ACKNOWLEDGEMENT_CREATED"] = "PROFILE_ACKNOWLEDGEMENT_CREATED";
    TradevestOnboardingEventType["PROFILE_ACKNOWLEDGEMENT_FAILED"] = "PROFILE_ACKNOWLEDGEMENT_FAILED";
    TradevestOnboardingEventType["TERMS_SIGNING_STARTED"] = "TERMS_SIGNING_STARTED";
    TradevestOnboardingEventType["TERMS_SIGNED"] = "TERMS_SIGNED";
    TradevestOnboardingEventType["TERMS_SIGNING_FAILED"] = "TERMS_SIGNING_FAILED";
    TradevestOnboardingEventType["PRIVACY_SIGNING_STARTED"] = "PRIVACY_SIGNING_STARTED";
    TradevestOnboardingEventType["PRIVACY_SIGNED"] = "PRIVACY_SIGNED";
    TradevestOnboardingEventType["PRIVACY_SIGNING_FAILED"] = "PRIVACY_SIGNING_FAILED";
    TradevestOnboardingEventType["QUALIFICATION_SUBMITTED"] = "QUALIFICATION_SUBMITTED";
    TradevestOnboardingEventType["QUALIFICATION_RISK_ACKNOWLEDGED"] = "QUALIFICATION_RISK_ACKNOWLEDGED";
    TradevestOnboardingEventType["QUALIFICATION_SYNCED_FROM_PARTNER"] = "QUALIFICATION_SYNCED_FROM_PARTNER";
    TradevestOnboardingEventType["ONBOARDING_REQUEST_STARTED"] = "ONBOARDING_REQUEST_STARTED";
    TradevestOnboardingEventType["ONBOARDING_REQUEST_CREATED"] = "ONBOARDING_REQUEST_CREATED";
    TradevestOnboardingEventType["ONBOARDING_REQUEST_FAILED"] = "ONBOARDING_REQUEST_FAILED";
    TradevestOnboardingEventType["ONBOARDING_STATUS_POLLED"] = "ONBOARDING_STATUS_POLLED";
    TradevestOnboardingEventType["ONBOARDING_APPROVED"] = "ONBOARDING_APPROVED";
    TradevestOnboardingEventType["ONBOARDING_REJECTED"] = "ONBOARDING_REJECTED";
    TradevestOnboardingEventType["ONBOARDING_INVALID"] = "ONBOARDING_INVALID";
    TradevestOnboardingEventType["BALANCE_ACCOUNT_CREATION_STARTED"] = "BALANCE_ACCOUNT_CREATION_STARTED";
    TradevestOnboardingEventType["BALANCE_ACCOUNT_CREATED"] = "BALANCE_ACCOUNT_CREATED";
    TradevestOnboardingEventType["BALANCE_ACCOUNT_CREATION_FAILED"] = "BALANCE_ACCOUNT_CREATION_FAILED";
    TradevestOnboardingEventType["CRYPTO_WALLET_CREATION_STARTED"] = "CRYPTO_WALLET_CREATION_STARTED";
    TradevestOnboardingEventType["CRYPTO_WALLET_CREATED"] = "CRYPTO_WALLET_CREATED";
    TradevestOnboardingEventType["CRYPTO_WALLET_CREATION_FAILED"] = "CRYPTO_WALLET_CREATION_FAILED";
    TradevestOnboardingEventType["ONBOARDING_COMPLETED"] = "ONBOARDING_COMPLETED";
    TradevestOnboardingEventType["ONBOARDING_FAILED"] = "ONBOARDING_FAILED";
    TradevestOnboardingEventType["STATUS_CHANGE"] = "STATUS_CHANGE";
    TradevestOnboardingEventType["API_REQUEST"] = "API_REQUEST";
    TradevestOnboardingEventType["API_RESPONSE"] = "API_RESPONSE";
    TradevestOnboardingEventType["API_ERROR"] = "API_ERROR";
    TradevestOnboardingEventType["WEBHOOK_RECEIVED"] = "WEBHOOK_RECEIVED";
    TradevestOnboardingEventType["WEBHOOK_PROCESSED"] = "WEBHOOK_PROCESSED";
    TradevestOnboardingEventType["WEBHOOK_ERROR"] = "WEBHOOK_ERROR";
    TradevestOnboardingEventType["ERROR"] = "ERROR";
    TradevestOnboardingEventType["INFO"] = "INFO";
    TradevestOnboardingEventType["WARNING"] = "WARNING";
    TradevestOnboardingEventType["DOCUMENTS_SIGNED"] = "DOCUMENTS_SIGNED";
    TradevestOnboardingEventType["IDENTIFICATION_CREATED"] = "IDENTIFICATION_CREATED";
    TradevestOnboardingEventType["PRODUCT_CREATED"] = "PRODUCT_CREATED";
    TradevestOnboardingEventType["MANUAL_RETRY"] = "MANUAL_RETRY";
    TradevestOnboardingEventType["MANUAL_RESET"] = "MANUAL_RESET";
    TradevestOnboardingEventType["MANUAL_STATUS_OVERRIDE"] = "MANUAL_STATUS_OVERRIDE";
})(TradevestOnboardingEventType || (TradevestOnboardingEventType = {}));
export var TradevestOnboardingEventSeverity;
(function (TradevestOnboardingEventSeverity) {
    TradevestOnboardingEventSeverity["DEBUG"] = "DEBUG";
    TradevestOnboardingEventSeverity["INFO"] = "INFO";
    TradevestOnboardingEventSeverity["WARNING"] = "WARNING";
    TradevestOnboardingEventSeverity["ERROR"] = "ERROR";
})(TradevestOnboardingEventSeverity || (TradevestOnboardingEventSeverity = {}));
export const TRADEVEST_ONBOARDING_EVENT_CAP = 2000;
//# sourceMappingURL=tradevest.types.js.map